import ClassAttendanceV2 from '@/api/class-attendance-v2'
import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  termList: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_TERM_LIST(state, data) {
    state.termList = data
  }
}

export const actions = {
  fetch(context, attributes = {}) {
    return ClassAttendanceV2.get({ params: attributes }).then(response => {
      return Promise.resolve(response)
    })
  },

  store(context, data) {
    return ClassAttendanceV2.store(data)
  },

  async dataBeforeCreate(context) {
    let response = await ClassAttendanceV2.formViewModel({
      params: {
        fnName: 'academic_term'
      }
    })

    Object.keys(response.data).forEach(key => {
      if (key == 'academic_term') {
        context.commit('SET_TERM_LIST', response.data[key])
      }
    })
  },
  async getClass(context, ac_term_id) {
    let response = await ClassAttendanceV2.formViewModel({
      params: {
        fnName: 'getClass',
        ac_term_id
      }
    })
    return {
      data: response.data.getClass
    }
  },
  async getTeacher(context, class_id) {
    let response = await ClassAttendanceV2.formViewModel({
      params: {
        fnName: 'getTeacher',
        class_id
      }
    })
    return {
      data: response.data.getTeacher
    }
  }
}
